export default "/images/vendor/flag-icon-css/flags/4x3/hm.svg?eb884befd701cebde39f5f019154c970";